import { Lock } from "lucide-react";
import type { ReactNode } from "react";

export interface SubTabSpec<T extends string> {
  id: T;
  label: string;
  locked?: boolean;
  icon?: ReactNode;
}

interface Props<T extends string> {
  tabs: SubTabSpec<T>[];
  active: T;
  onChange: (id: T) => void;
}

export function SubTabs<T extends string>({ tabs, active, onChange }: Props<T>) {
  return (
    <div className="border-b border-white/10 flex items-center gap-1 overflow-x-auto">
      {tabs.map((t) => {
        const isActive = t.id === active;
        return (
          <button
            key={t.id}
            type="button"
            disabled={t.locked}
            onClick={() => !t.locked && onChange(t.id)}
            className={
              "px-4 py-3 text-sm transition-colors flex items-center gap-2 border-b-2 whitespace-nowrap " +
              (isActive
                ? "border-indra-turquesa text-white font-semibold"
                : t.locked
                  ? "border-transparent text-white/30 cursor-not-allowed"
                  : "border-transparent text-white/60 hover:text-white hover:bg-white/5")
            }
          >
            {t.icon}
            <span>{t.label}</span>
            {t.locked && <Lock size={12} />}
          </button>
        );
      })}
    </div>
  );
}
